// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"86":"auth-module","537":"main-module","647":"bulk add edit students page"}[chunkId] || chunkId) + "." + {"86":"ba13d1e8","95":"61264c8b","125":"b8f189ce","179":"c5cdd1ee","234":"7d5f97d5","357":"bff927e5","537":"c3ada465","570":"383adff9","647":"1001573f","811":"8936b9a6"}[chunkId] + ".js";
};